"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIntl = require("react-intl");

var _Box = _interopRequireDefault(require("@match/react-component-library/components/Box"));

var _VisuallyHidden = _interopRequireDefault(require("@match/react-component-library/components/VisuallyHidden"));

var _messages = require("../../constants/messages");

var _routes = require("../../constants/routes");

var _components = require("../../components");

var _Logo = _interopRequireDefault(require("./Logo"));

function LogoWithNav(_ref) {
  var customLinkRenderer = _ref.customLinkRenderer,
      siteName = _ref.siteName;
  var intl = (0, _reactIntl.useIntl)();

  var label = _react.default.useRef(intl.formatMessage({
    id: _messages.MESSAGE_ID.HOME
  }));

  return _react.default.createElement(_Box.default, {
    display: "flex",
    alignItems: "center",
    width: 120
  }, _react.default.createElement(_components.LinkRenderer, {
    customLinkRenderer: customLinkRenderer,
    routeHref: _routes.ROUTE.HOME
  }, _react.default.createElement(_VisuallyHidden.default, null, label.current), _react.default.createElement(_Logo.default, {
    siteName: siteName,
    light: true,
    height: 30,
    width: 165,
    "aria-hidden": true
  })));
}

var _default = LogoWithNav;
exports.default = _default;